'use client';
import { PageLayout } from '@xtnd/web/shared/layout';
import { MatterArDetailProvider } from '../components/common';
import { InvoiceDetailProvider } from '../components/common/InvoiceContext';
import WriteOffs from '../components/write-offs/WriteOffs';

export default function WriteOffsPage() {
  return (
    <PageLayout
      title="Current Write-off Queue"
      description="Review and manage current write-off queue."
    >
      <MatterArDetailProvider>
        <InvoiceDetailProvider>
          <WriteOffs />
        </InvoiceDetailProvider>
      </MatterArDetailProvider>
    </PageLayout>
  );
}
